import { mount } from '../dom-lifecycle';

// Licznik znaków opinii — „X/max" w prawym dolnym rogu textarea. Widoczność steruje CSS
// (pojawia się dopiero, gdy pole ma treść — reguła `textarea:not(:placeholder-shown)`);
// tu tylko liczymy znaki i podbijamy stan `is-valid` po osiągnięciu minimalnej długości.
mount('[data-review-count]', function () {
    const field = this.closest('.af-review__field');
    const ta = field?.querySelector('textarea');
    if (!ta) return;

    const max = ta.maxLength > 0 ? ta.maxLength : 500;
    const min = parseInt(ta.getAttribute('minlength') || '0', 10);

    const update = () => {
        const len = ta.value.length;
        this.textContent = `${len}/${max}`;
        this.classList.toggle('is-valid', len >= min && len <= max);
    };

    ta.addEventListener('input', update);
    update();
});
